class StreamUseCase {
    constructor(streamRepo) {
        this.streamRepo = streamRepo;
    }
    streamQuote(streaming_type, subscribe, callBack, symbols, streamKey) {
        this.streamRepo.streamQuote(streaming_type, subscribe, callBack, symbols, streamKey);
    }
}
export default StreamUseCase;
